/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".user-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%] {\n  border-radius: 10%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3VzZXItaWNvbi5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUdFLGtCQUFBO0FBQ0YiLCJmaWxlIjoidXNlci1pY29uLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnVzZXItaWNvbiBpbWcge1xuICAtd2Via2l0LWJvcmRlci1yYWRpdXM6IDEwJTtcbiAgLW1vei1ib3JkZXItcmFkaXVzOiAxMCU7XG4gIGJvcmRlci1yYWRpdXM6IDEwJTtcbn1cbiJdfQ== */"];
export { styles as styles };

